import { View } from './view'

export const SignShortApplicationScreen = View
